import { Icon } from "@mui/material";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import Status from "../../types/enum/Status";
import { ClickableIcon } from "../../components/Icon";
import styled from "styled-components";

interface Props {
  isMobile?: boolean;
  HeaderBox: any;
  setOpen: any;
  setAnnouncement: any;
  announcement: any;
}
export const ConfirmPin = (props: Props) => {
  const { isMobile, HeaderBox, setOpen, setAnnouncement, announcement } = props;
  const StyledBody = styled("div")`
    padding: 30;
    margin: 30px;
  `;
  const StyledText = styled("div")`
    padding: 40px;
    background: #59595926;
    margin-bottom: 30px;
    border-radius: 7px;
  `;
  return (
    <>
      <HeaderBox>
        <Icon
          sx={{
            color: "#ffff86",
            mr: 1,
            textShadow: "0 1px 5px black",
          }}
        >
          warning_amber_rounded_icon
        </Icon>
        <FlexGrow>Are you sure?</FlexGrow>
        <ClickableIcon
          name="times"
          onClick={() => console.log("ji")}
          style={{ color: "white" }}
        />
      </HeaderBox>
      <StyledBody>
        <StyledText>
          Note that pinning this announcement will unpin any other
          announcements. <br />
          Do you want to continue?
        </StyledText>
        <FlexBox justify="end">
          <Button
            type="button"
            style={{
              width: props.isMobile ? "80px" : "150px",
              height: "48px",
            }}
            isOutline
            status={Status.default}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <FlexGrow
            style={{ flexGrow: "0", display: "flex", justifyContent: "end" }}
          >
            <Button
              onClick={() => {
                setAnnouncement({
                  ...announcement,
                  pinned: true,
                });
                setOpen(false);
              }}
              style={{
                width: props.isMobile ? "80px" : "150px",
                height: "48px",
                padding: "13px 12px",
              }}
              status={Status.button}
            >
              Continue
            </Button>
          </FlexGrow>
        </FlexBox>
      </StyledBody>
    </>
  );
};
